<div class="layout-container w-full bg-gray-100" [class.sidebar-collapsed]="!sidebarOpen">
  <!-- Sidebar -->
  <div class="sidebar bg-sky-600 text-white transition-all duration-300" [class.w-64]="sidebarOpen" [class.w-16]="!sidebarOpen">
    <!-- Sidebar Header -->
    <div class="p-4 border-b border-sky-500">
      <div class="flex items-center">
        <span *ngIf="sidebarOpen" class="text-xl font-bold">
          <img src="assets/images/sg_white.png" alt="logo" class="w-auto h-13">
        </span>
      </div>
    </div>
    
    <!-- Navigation Items -->
    <nav class="mt-4">
      <div *ngFor="let item of navigationItems" class="mb-2">
        <!-- Main Category -->
         <!-- make dynamic active class on route url match-->
        <div class="px-4 py-3 flex items-center cursor-pointer hover:bg-sky-700 transition-colors"
             [class.bg-sky-700]="item.route === `${routerUrl}`"
             (click)="navigateToPage(item.route)">
          <i [class]="item.icon" class="text-lg mr-3"></i>
          <span *ngIf="sidebarOpen" class="font-medium">{{ item.category }}</span>
        </div>
      </div>
    </nav>
    <!-- create user profile button, make boxy looking -->
     <!-- move to the bottom of the sidebar -->
    <div class="absolute bottom-0 left-0 right-0">
    
        <div class="px-4 py-3 flex items-center cursor-pointer hover:bg-sky-700 transition-colors"
            (click)="navigateToPage('logout')">
        <i class="pi pi-sign-out text-lg mr-3"></i>
        <span *ngIf="sidebarOpen" class="font-medium">Logout</span>
        </div>

        <div class="p-4 border-t border-sky-400/30">
            <div class="flex items-center px-4 py-3 bg-white/10 rounded-xl hover:bg-white/15 transition-all duration-200">
              <div class="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center mr-3">
                <i class="pi pi-user text-white text-lg"></i>
              </div>
              <div class="flex-1">
                <h4 class="font-medium text-sm text-white">Raveendar</h4>
                <p class="text-xs text-sky-200">Admin</p>
              </div>
              <button class="text-white/70 hover:text-white transition-colors duration-200">
                <i class="pi pi-ellipsis-v"></i>
              </button>
            </div>
          </div>

    </div>
  </div>
  
  <!-- Main Content Area -->
  <div class="main-content-wrapper flex flex-col overflow-hidden w-full">
    <!-- Header -->
    <header class="header bg-white shadow-sm border-b border-gray-200 px-6 py-4 w-full">
      <div class="flex items-center justify-between">
        <div class="flex items-center">
          <button (click)="toggleSidebar()" 
                  class="p-2 rounded-md hover:bg-gray-100 transition-colors">
            <i class="pi pi-bars text-gray-600"></i>
          </button>
          <h1 class="ml-4 text-2xl font-semibold text-gray-800">Profile</h1>
        </div>
        
        <!-- User Info -->
        <!-- <div class="flex items-center space-x-4">
          <div class="flex items-center space-x-2">
            <img src="https://via.placeholder.com/32x32" alt="Profile" class="w-8 h-8 rounded-full">
            <span class="text-gray-700 font-medium">Raveendar</span>
          </div>
        </div> -->
      </div>
    </header>
    
    <!-- Main Content -->
    <main class="main-content flex-1 overflow-y-auto p-6 ">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
